// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2K3bY","head":"ProcedureTableInfo_head__11bMf"};